import React from "react";
import { CONSTANTS } from "../../config";
import { handleSort, type } from "../helper/Constant";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import _ from "lodash";

let url = "/admin-attendance/";

// Helper function to format time in 12-hour format with correct AM/PM
const formatTime12Hour = (timeDecimal) => {
  if (!timeDecimal || timeDecimal === '0' || timeDecimal === 0) return '_';

  const timeStr = timeDecimal.toString();
  const [hoursStr, minutesStr = '00'] = timeStr.split('.');
  const hours24 = parseInt(hoursStr, 10);
  const minutes = minutesStr.length === 1 ? minutesStr + '0' : minutesStr;

  // Convert 24-hour to 12-hour format
  // 0 -> 12 AM, 1-11 -> 1-11 AM, 12 -> 12 PM, 13-23 -> 1-11 PM
  const hours12 = hours24 === 0 ? 12 : hours24 > 12 ? hours24 - 12 : hours24;
  const period = hours24 >= 12 ? 'PM' : 'AM';

  return `${hours12}:${minutes} ${period}`;
};

const ViewAdminAttendance = (props) => {
  const location = useLocation();
  const hideActions = location.pathname.startsWith("/admin-attendance-report");
  const {
    sortType,
    sortField,
    AttendanceDetails,
    pageNo,
    handleOpenEditAttendancePopup,
    handleOpenDeleteAttendancePopup,
    handleOpenLeavePopup,
    checkBox,
    dispatch,
  } = props;
  return (
    <div class="table-responsive" style={hideActions ? { border: "1px solid lightgray", borderCollapse: "collapse" } : {}}>
      <table className="table table-bordered" >
        <thead className="white bg_blue">
          <tr>
            <th scope="col">S.No</th>
            <th scope="col">
              Employee ID
              <i
                className={
                  sortType === CONSTANTS.SORT_TYPE_CONSTANTS.Asscending &&
                    sortField === "mobId"
                    ? "fa fa-sort-numeric-asc ml-2"
                    : "fa fa-sort-numeric-desc ml-2"
                }
                onClick={() => handleSort("mobId", dispatch, sortType)}
              ></i>
            </th>
            <th>
              Name
              <i
                className={
                  sortType === CONSTANTS.SORT_TYPE_CONSTANTS.Asscending &&
                    sortField === "employeeName"
                    ? "fa fa-sort-alpha-asc ml-2"
                    : "fa fa-sort-alpha-desc ml-2"
                }
                onClick={() => handleSort("employeeName", dispatch, sortType)}
              ></i>
            </th>

            <th scope="col">Date</th>
            <th scope="col">Check In</th>
            <th scope="col">Late Check In</th>
            <th scope="col">Early Check Out</th>
            <th scope="col">Check Out</th>
            <th scope="col">
              Total Hours
              <i
                className={
                  sortType === CONSTANTS.SORT_TYPE_CONSTANTS.Descending &&
                    sortField === "totalHours"
                    ? "fa fa-sort-numeric-desc ml-2"
                    : "fa fa-sort-numeric-asc ml-2"
                }
                onClick={() => handleSort("totalHours", dispatch, sortType)}
              ></i>
            </th>
            {!hideActions && (
              <th scope="col" style={{ width: 120 }}>
                Action
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(AttendanceDetails)
            ? AttendanceDetails.map((data, i) => (
              <tr>
                <td>
                  {
                    hideActions ? <span className="cm_col">{i + 1}</span> : <span className="cm_col">{i + 1 + (pageNo - 1) * 10}</span>
                  }
                </td>
                <td>
                  <span className="cm_col"> {data.mobId}</span>
                </td>
                <td>
                  <span className="cm_col">
                    {
                      hideActions ? (data.employeeName) :
                        (<Link
                          to={{
                            pathname: `${url}${data.employeeId}`,
                            state: { empName: data.employeeName },
                          }}
                        >
                          {data.employeeName}
                        </Link>)
                    }
                  </span>
                </td>
                <td>
                  {new Date(data.date).getDate().toString().padStart(2, "0") +
                    "/" +
                    (new Date(data.date).getMonth() + 1)
                      .toString()
                      .padStart(2, "0") +
                    "/" +
                    new Date(data.date)
                      .getFullYear()
                      .toString()
                      .padStart(2, "0")}
                </td>
                <td>
                  <time>
                    {data.checkIn > "0" &&
                      (data.checkIn.includes(".")
                        ? parseInt(
                          +data.checkIn.split(".")[0] * 60 * 60 +
                          +data.checkIn.split(".")[1] * 60
                        )
                        : parseInt(data.checkIn * 60 * 60)) <=
                      data.reportingTime + 1800
                      ? formatTime12Hour(data.checkIn)
                      : "_"}
                  </time>
                </td>
                <td className="text-danger">
                  <time>
                    {data.checkIn > "0" &&
                      (data.checkIn.includes(".")
                        ? parseInt(
                          +data.checkIn.split(".")[0] * 60 * 60 +
                          +data.checkIn.split(".")[1] * 60
                        )
                        : parseInt(data.checkIn * 60 * 60)) >
                      data.reportingTime + 1800
                      ? formatTime12Hour(data.checkIn)
                      : "_"}
                  </time>
                </td>
                <td>
                  <span className="text-danger">
                    <time>
                      {data.checkOut > "0" &&
                        data.totalHours < 30600 &&
                        data.checkIn !== "0"
                        ? formatTime12Hour(data.checkOut)
                        : "_"}
                    </time>
                  </span>
                </td>
                <td>
                  {data.checkOut > "0" ? (
                    data.totalHours === 0 || data.totalHours >= 30600 ? (
                      <time>{formatTime12Hour(data.checkOut)}</time>
                    ) : (
                      "_"
                    )
                  ) : (
                    "_"
                  )}
                </td>

                <td>
                  {moment.utc(data.totalHours * 1000).format("HH:mm") <
                    moment.utc(30600 * 1000).format("HH:mm") &&
                    moment.utc(data.totalHours * 1000).format("HH:mm") >=
                    moment.utc(28800 * 1000).format("HH:mm") ? (
                    <time title="View attendance record" className="yellow">
                      {data.totalHours
                        ? moment.utc(data.totalHours * 1000).format("HH.mm")
                        : "00.00"}
                    </time>
                  ) : moment.utc(data.totalHours * 1000).format("HH:mm") <
                    moment.utc(30600 * 1000).format("HH:mm") ? (
                    <time
                      title="View attendance record"
                      className="text-danger"
                    >
                      {data.totalHours
                        ? moment.utc(data.totalHours * 1000).format("HH.mm")
                        : "00.00"}
                    </time>
                  ) : (
                    <time title="View attendance record" className="green">
                      {data.totalHours
                        ? moment.utc(data.totalHours * 1000).format("HH.mm")
                        : "00.00"}
                    </time>
                  )}
                </td>
                {!hideActions && (
                  <td style={{ width: 160 }}>
                    <div className="cm_device">
                      <span onClick={() => handleOpenEditAttendancePopup(data)}>
                        <i
                          className="fa fa-pencil"
                          aria-hidden="true"
                          title="Edit attendance"
                        ></i>
                      </span>
                      <span
                        onClick={() => handleOpenDeleteAttendancePopup(data)}
                      >
                        <i
                          className="fa fa-trash-o ml-4 red"
                          title="Delete attendance"
                        ></i>
                      </span>
                      {data.leaveId != "" ? (
                        <span onClick={() => handleOpenLeavePopup(data)}>
                          <i
                            className="fa fa-clock-o red ml-4"
                            aria-hidden="true"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                      <span>
                        {checkBox !== "" && data.leaveId !== "" ? (
                          <input
                            className=" ml-3 "
                            name="editEmployee"
                            type="checkbox"
                            value={data.employeeId}
                          />
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                  </td>
                )}
              </tr>
            ))
            : ""}
        </tbody>
      </table>
      {AttendanceDetails && AttendanceDetails.length > 0 ? (
        ""
      ) : (
        <h3 className="text-center">No data available</h3>
      )}
    </div>
  );
};

export default ViewAdminAttendance;
